export enum TicketSellerType {
  PERSONAL = 'PERSONAL',
  COMPANY = 'COMPANY',
}
